/** @jsx jsx */
import { Spacer, Spinner } from "@cd2/components"
import { H3 } from "@cd2/text"
import { css, jsx } from "@emotion/core"
import { motion } from "framer-motion"
import { FileboyImageOrLocalBackgroundImage } from "./FileboyImageOrLocal"

interface IProps {
  isLoaded?: boolean
  loadingText?: string
  noInitialAnimation?: boolean
}

export function LoadingScreen({
  isLoaded,
  loadingText = "LOADING...",
  noInitialAnimation,
}: IProps) {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={
        isLoaded
          ? {
              opacity: 0,
              transitionEnd: {
                display: "none",
              },
            }
          : undefined
      }
      transition={{ duration: 0.5, delay: 1 }}
    >
      <div
        css={css`
          position: absolute;
          z-index: 20;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding: calc(20vh) 0;
          background: white;
          min-height: 750px;
        `}
      >
        <motion.div
          initial={{ opacity: noInitialAnimation ? 1 : 0 }}
          animate={{ opacity: isLoaded ? 0 : 1 }}
          transition={isLoaded ? { delay: 0.5 } : undefined}
        >
          <FileboyImageOrLocalBackgroundImage
            image={"bear"}
            css={css`
              height: 130px;
            `}
            contain
          />
          <Spacer size={32} />
          <H3 align="center" color="secondary">
            {loadingText}
          </H3>
          <Spacer size={20} />
          <div
            css={css`
              margin: 0 auto;
              height: 40px;
              width: 40px;
              display: block;
            `}
          >
            <Spinner size={50} color="#0c9298" />
          </div>
        </motion.div>
      </div>
    </motion.div>
  )
}
